/**
 * Created by jiachenpan on 16/11/18.
 */
import { Message } from "element-ui";
import moment from "moment";

// 根据GMT+8时区格式化时间
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  if (time === "" || !time) {
    return null;
  }
  const format = cFormat || "YYYY-MM-DD HH:mm:ss";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formattedDate = moment(date)
    .utcOffset("+08:00")
    .format(format);
  if (formattedDate.indexOf('Invalid') != -1 || formattedDate.indexOf('NaN') != -1) {
    return null;
  }
  return formattedDate;
}

export function parseTime2(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  if (time === "") {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/gi) != null) {
      len += 1;
    } else {
      len += 0.5;
    }
  }
  return Math.floor(len);
}

export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
}

export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

export const pickerOptions = [
  {
    text: "今天",
    onClick(picker) {
      const end = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
      const start = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "昨天",
    onClick(picker) {
      const start = new Date(
        new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24
      );
      const end = new Date(start.getTime() + 24 * 60 * 60 * 1000 - 1);
      picker.$emit("pick", [start, end]);
    }
  },
  {
    text: "近三天",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 3);
      picker.$emit("pick", [
        start,
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        )
      ]);
    }
  },
  {
    text: "近一周",
    onClick(picker) {
      const end = new Date(new Date().toDateString());
      const start = new Date();
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [
        start,
        new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
        )
      ]);
    }
  },
  {
    text: "本月",
    onClick(picker) {
      const end = new Date();
      const start = new Date(end.getFullYear(), end.getMonth(), 1);
      picker.$emit("pick", [start, end]);
    }
  } // ,
  // {
  //   text: '最近一周',
  //   onClick(picker) {
  //     const end = new Date(new Date().toDateString())
  //     const start = new Date()
  //     start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
  //     picker.$emit('pick', [start, end])
  //   }
  // },
  // {
  //   text: '最近一个月',
  //   onClick(picker) {
  //     const end = new Date(new Date().toDateString())
  //     const start = new Date()
  //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
  //     picker.$emit('pick', [start, end])
  //   }
  // },
  // {
  //   text: '最近三个月',
  //   onClick(picker) {
  //     const end = new Date(new Date().toDateString())
  //     const start = new Date()
  //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
  //     picker.$emit('pick', [start, end])
  //   }
  // }
];

export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "shallowClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

// 通道列表导出
async function formatterExport(list) {
  // 构造 导出使用的拼接字段
  list.forEach(item => {
    // 通道费率
    if (item.poundageUnit === 1) {
      if (item.poundage) {
        item.exportChannelRate = item.poundage + " %";
      }
      if (item.poundageSecond) {
        item.exportChannelRate = item.poundageSecond + " 元";
      }
      if (item.poundage && item.poundageSecond) {
        item.exportChannelRate =
          item.poundage + " % + " + item.poundageSecond + " 元";
      }
    } else {
      if (item.poundageSecond) {
        item.exportChannelRate = item.poundageSecond + " %";
      }
      if (item.poundage) {
        item.exportChannelRate = item.poundage + " 元";
      }
      if (item.poundage && item.poundageSecond) {
        item.exportChannelRate =
          item.poundageSecond + " % + " + item.poundage + " 元";
      }
    }
    // 商户费率
    if (item.merchRatioUnit === 1) {
      if (item.merchRatio) {
        item.exportMerchatRate = item.merchRatio + " %";
      }
      if (item.merchRatioSecond) {
        item.exportMerchatRate = item.merchRatioSecond + " 元";
      }
      if (item.merchRatio && item.merchRatioSecond) {
        item.exportMerchatRate =
          item.merchRatio + " % + " + item.merchRatioSecond + " 元";
      }
    } else {
      if (item.merchRatioSecond) {
        item.exportMerchatRate = item.merchRatioSecond + " %";
      }
      if (item.merchRatio) {
        item.exportMerchatRate = item.merchRatio + " 元";
      }
      if (item.merchRatio && item.merchRatioSecond) {
        item.exportMerchatRate =
          item.merchRatioSecond + " % + " + item.merchRatio + " 元";
      }
    }
    // 通道类型名称 拼接
    item.exportChannelName =
      "【" +
      item.code +
      "】" +
      item.name +
      (item.payCode ? "【" + item.payCode + "】" : "");
    // 信用额度状态 拼接
    item.exportCredits =
      "【" +
      (item.creditsStatus == 1 ? "开" : "关") +
      "】" +
      item.channelPlatformCredits;
  });
}

// 导出excel方法
export function exportExcel(total, listQuery, fetchList, _this, type) {
  return new Promise((resolve, reject) => {
    // console.log('total', total)  //检测下total是否正确
    // 调整参数  是否分线程组装
    if (total === 0) {
      Message.error("暂无数据");
      resolve();
    } else if (total <= 300) {
      const parmas = Object.assign({}, listQuery);
      parmas.pageSize = total;
      // 7/7 注意后端命名是否为pageNo
      parmas.pageNo = 1;
      fetchList(parmas).then(async res => {
        if (type == "channel-list") {
          //通道列表
          await formatterExport(res.list);
          resolve(res.list);
        } else {
          resolve(res.list);
        }
      });
    } else {
      if (total > 100000) {
        Message.success("最多只能导出100000条信息，正在为你导出...");
        total = 100000;
      }
      // 请求次数
      const requestTimes = Math.ceil(total / 300); // 300条一个请求
      // 总循环次数
      const turnTimes = Math.ceil(requestTimes / 3);
      // 当前循环次数
      let nown = 1;
      const allListData = []; // 数据顺序数组
      // n 为第几次循环
      const turnTime = n => {
        return new Promise(next => {
          // console.log('第', n, '次循环')
          const PromiseArr = [];
          for (let i = 3 * (n - 1); i < 3 * n; i++) {
            if (i > requestTimes - 1) {
              break;
            }
            const parmas = Object.assign({}, listQuery);
            parmas.pageSize = 300;
            PromiseArr.push(
              (() => {
                return new Promise(open => {
                  parmas.pageNo = i + 1;
                  let unitData = []; // 每页数组
                  fetchList(parmas).then(res => {
                    unitData = res.list.map(v => v);
                    allListData[i] = unitData;
                    open();
                  });
                });
              })()
            );
          }
          Promise.all(PromiseArr).then(() => {
            // console.log('第', n, '轮请求完成')
            next();
          });
        });
      };
      const getRes = () => {
        return new Promise(() => {
          _this.downloadStatu = 0;
          // console.log('[].concat.apply([], allListData)', [].concat.apply([], allListData))
          resolve([].concat.apply([], allListData));
        });
      };
      const fuc = () => {
        // console.log('nown', nown)
        // console.log('turnTimes', turnTimes)
        _this.downloadStatu =
          nown === turnTimes ? 0 : parseInt(100 * (nown / turnTimes));
        turnTime(nown).then(() => {
          nown += 1;
          if (nown < turnTimes || nown === turnTimes) {
            fuc();
          } else {
            getRes();
          }
        });
      };
      fuc();
    }
  });
}

var pickerMinDate = "";
export const onPick = ({ maxDate, minDate }) => {
  pickerMinDate = minDate ? minDate.getTime() : "";
  if (maxDate) {
    pickerMinDate = "";
  }
};

export const disabledDate = time => {
  const day30 = 31 * 24 * 3600 * 1000;
  if (pickerMinDate) {
    const maxTime = pickerMinDate + day30;
    const minTime = pickerMinDate - day30;
    // if (maxTime > new Date().getTime()) {
    //   maxTime = new Date().getTime() + 24 * 3600 * 1000
    // }
    return time.getTime() > maxTime || time.getTime() < minTime;
  }
  // return time.getTime() > Date.now()
};
export const disabledDate62 = time => {
  const day30 = 62 * 24 * 3600 * 1000;
  if (pickerMinDate) {
    const maxTime = pickerMinDate + day30;
    const minTime = pickerMinDate - day30;
    // if (maxTime > new Date().getTime()) {
    //   maxTime = new Date().getTime() + 24 * 3600 * 1000
    // }
    return time.getTime() > maxTime || time.getTime() < minTime;
  }
  // return time.getTime() > Date.now()
};

// 回显数据字典 label value
export function selectDictLabel(datas, value) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  Object.keys(datas).some(key => {
    if (datas[key].value == "" + value) {
      actions.push(datas[key].label);
      return true;
    }
  });
  if (actions.length === 0) {
    actions.push(value);
  }
  return actions.join("");
}

/**
 * 数字相加
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export const accAdd = function(arg1, arg2) {
  return changeNum(arg1, arg2);
};

/**
 * 数字相减
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export const accSub = function(arg1, arg2) {
  return changeNum(arg1, arg2, false);
};

/**
 * 数字相乘
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export const accMul = function(arg1, arg2) {
  let m = 0;
  m = accAdd(m, getDecimalLength(arg1));
  m = accAdd(m, getDecimalLength(arg2));
  return (getNum(arg1) * getNum(arg2)) / Math.pow(10, m);
};

/**
 * 数字相除
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export const accDiv = function(arg1, arg2) {
  let t1, t2;
  t1 = getDecimalLength(arg1);
  t2 = getDecimalLength(arg2);
  if (t1 - t2 > 0) {
    return getNum(arg1) / getNum(arg2) / Math.pow(10, t1 - t2);
  } else {
    return (getNum(arg1) / getNum(arg2)) * Math.pow(10, t2 - t1);
  }
};

function changeNum(arg1 = "", arg2 = "", isAdd = true) {
  function changeInteger(arg, r, maxR) {
    if (r != maxR) {
      let addZero = "";
      for (let i = 0; i < maxR - r; i++) {
        addZero += "0";
      }
      arg = Number(arg.toString().replace(".", "") + addZero);
    } else {
      arg = getNum(arg);
    }
    return arg;
  }
  let r1, r2, maxR, m;
  r1 = getDecimalLength(arg1);
  r2 = getDecimalLength(arg2);
  maxR = Math.max(r1, r2);
  arg1 = changeInteger(arg1, r1, maxR);
  arg2 = changeInteger(arg2, r2, maxR);
  m = Math.pow(10, maxR);
  if (isAdd) {
    return (arg1 + arg2) / m;
  } else {
    return (arg1 - arg2) / m;
  }
}

function getDecimalLength(arg = "") {
  try {
    return arg.toString().split(".")[1].length;
  } catch (e) {
    return 0;
  }
}

function getNum(arg = "") {
  return Number(arg.toString().replace(".", ""));
}

/* 
  const decimalPlaces = 2; // 设置要截取的小数位数   
  const useThousandsSeparator = true; // 动态设置是否使用千分位
*/
export const mixDecimalToFixed = function(
  number,
  decimalPlaces = 2,
  useThousandsSeparator = true
) {
  if (isNaN(number)) {
    return "";
  }
  // 将数字转换为字符串
  let numberString = number.toString().trim();

  // 移除非数字和负号字符，保留最后一个负号
  const isNegative = numberString.startsWith("-");
  numberString = numberString.replace(/[^0-9.]/g, "");
  numberString = (isNegative ? "-" : "") + numberString;

  // 解析为浮点数
  let floatValue = parseFloat(numberString);

  // 截取小数位
  if (!isNaN(floatValue)) {
    // 查找小数点的位置
    const decimalIndex = numberString.indexOf(".");
    // 如果没有小数部分或小数部分长度小于等于decimalPlaces，则直接返回原始数字
    if (
      decimalIndex === -1 ||
      numberString.length - decimalIndex <= decimalPlaces + 1
    ) {
      floatValue = number;
    } else {
      // 对小数部分进行截取
      const truncatedDecimal = numberString.substr(
        0,
        decimalIndex + decimalPlaces + 1
      );
      // 返回截取后的数字（字符串转换为数字）
      floatValue = parseFloat(truncatedDecimal);
    }
  }

  // 格式化千分位
  if (useThousandsSeparator && !isNaN(floatValue)) {
    // 将数字转换为字符串，并将小数部分和整数部分分开
    const parts = floatValue.toString().split(".");
    // 格式化整数部分（添加分位符）
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // 组合整数部分和小数部分（如果存在）
    floatValue = parts.join(".");
  }

  return floatValue;
};

// 小数保留
export const mixDecimalToFixed2 = function(
  val,
  precision = 2,
  nullVal = null,
  isMillennium = true
) {
  if (val && typeof val === "number" && val !== 0) {
    let num = 0;
    const toStr = val.toString();
    const str = toStr.indexOf(".");
    if (str !== -1) {
      num = toStr.substring(0, toStr.indexOf(".") + precision + 1) - 0;
    } else {
      num = val;
    }
    if (isMillennium) {
      num = num.toLocaleString(undefined, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      });
    }
    return num;
  }
  if (nullVal != null) {
    return nullVal;
  } else {
    return 0;
  }
};

// 用科学计数法对运算结果进行四舍五入：利用“科学计数法”扩大 10 的 n 次不会出现精度丢失的特性
export const roundOff = function(number, precision = 2) {
  return Math.round(+number + "e" + precision) / Math.pow(10, precision);
};

// 给元素添加一个className
export function addClassName(obj, className) {
  if (obj.className == "") {
    obj.className = className;
  } else {
    obj.className += " " + className; //需要空格才生效
  }
}

// 删除元素的一个className
export function delClassName(obj, className) {
  var currentClassName = obj.className;
  if (currentClassName != "") {
    var currentClassNameArray = currentClassName.split(" ");
    var i = 0;
    for (i = 0; i < currentClassNameArray.length; i++) {
      if (currentClassNameArray[i] == className) {
        currentClassNameArray.splice(i, 1);
      }
    }
    var nowClassName = currentClassNameArray.join(" ");
    obj.className = nowClassName;
  }
}

// 导出文件流 适用于post方法，api.js声明处需要加responseType: 'blob'，否则提示文件格式无效
// total 总条数，listQuery 查询参数，fetchList 导出接口， fileName 文件名
export function exportDocument(total, listQuery, fetchList, fileName) {
  // 判断数据
  if (total == 0) {
    Message.error("暂无数据导出！");
  } else {
    // 处理参数
    const parmas = Object.assign({}, listQuery);
    parmas.pageNo = 1;
    parmas.pageSize = total > 100000 ? 100000 : total; //最大100000
    fetchList(parmas).then(async responseFlow => {
      Message.success("导出成功");
      if (responseFlow) {
        //1.我们需要通过blob对象来处理，需要模拟一个<a>标签来提供下载链接
        const link = document.createElement("a");
        link.style.display = "none";
        //2.blob是二进制大对象，接受后台返回的数据流，导出数据
        const blob = new Blob([responseFlow], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        //3.创建一个url 对象，并将blob实例作为参数传入，这样href的值就是以blob开头的一个文件流下载链接,类似于href="blob:http://127.0.0.1xxxxx"
        const blobUrl = URL.createObjectURL(blob);
        link.href = blobUrl;
        link.download = fileName; //下载后的文件名
        //4.将a标签加入body,并手动点击触发下载
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js